import type { ReactNode } from "react";
import { createPortal } from "react-dom";

/** The page's note, drawn over everything. Why: a sheet sits above the page, and a note about it must show. */
export function NativeToast({ children }: { children: ReactNode }) {
  return createPortal(<div className="ad-toastl">{children}</div>, document.body);
}
